import React, { memo, useMemo } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Icon } from 'shared/ui';

import { Dropdown } from './Dropdown/Dropdown';
import cls from './TasksSort.module.css';
import { useTasksSort } from '../lib/hooks/useTasksSort';

interface TasksSortProps {
    classes?: string;
    queryParams: URLSearchParams;
}

export const TasksSort = memo(({ classes, queryParams }: TasksSortProps) => {
    const { isSorted, initialTab, isHovered, toggleHover } = useTasksSort(queryParams);
    const { t } = useTranslation();
    const fillColor = useMemo(() => {
        if (isHovered && !isSorted) return '#1D2534';
        if (isHovered && isSorted) return '#0E79C9';
        if (!isHovered && isSorted) return '#1094F7';
        return undefined;
    }, [isHovered, isSorted]);

    return (
        <Dropdown classes={cls.TasksSortWrapper}>
            {initialTab === 'taskList' && (
                <div
                    title={t('Features.TasksSort.AttributeTitle.text')}
                    className={classNames(cls.TasksSort, [classes], {
                        [cls.hide]: initialTab !== 'taskList',
                    })}
                    onMouseEnter={toggleHover}
                    onMouseLeave={toggleHover}
                >
                    <Icon iconName="taskSort" fill={fillColor} />
                </div>
            )}
        </Dropdown>
    );
});
